import { Text } from 'ui/components/primitives';

import { Container } from './AboutYourOrder.styles';

import type { AboutYourOrderProps } from './AboutYourOrder.d';

export const AboutYourOrderBase = ({ paymentMethod, value = '', testId }: AboutYourOrderProps) => (
  <Container.Card data-testid={testId}>
    <Container.OrderInfo>
      <Text variant="body-large-short">Sobre seu pedido</Text>

      <Text variant="auxiliar-small">{`Valor à pagar: ${value}`}</Text>

      <Text variant="auxiliar-small">{`Forma de pagamento: ${paymentMethod}`}</Text>
    </Container.OrderInfo>
  </Container.Card>
);

export default AboutYourOrderBase;
